<nb-card>
  <nb-card-header>
    Smart Table
  </nb-card-header>

  <nb-card-body>
    <ng2-smart-table [settings]="settings" [source]="source" (deleteConfirm)="onDeleteConfirm($event)">
    </ng2-smart-table>
  </nb-card-body>
</nb-card>
